import React from 'react'
import {
  Control,
  FieldValues,
  Path,
  PathValue,
  RegisterOptions,
  useController,
} from 'react-hook-form'
import { TextInputV2, TextInputV2Props } from '@manychat/manyui'

type HookFormTextInputProps<Values extends FieldValues = FieldValues> = TextInputV2Props & {
  control?: Control<Values>
  name: Path<Values>
  rules?: RegisterOptions<Values>
  defaultValue?: PathValue<Values, Path<Values>>
}

export const HookFormTextInput = <Values extends FieldValues>({
  name: fieldName,
  rules,
  defaultValue,
  control,
  ...passProps
}: HookFormTextInputProps<Values>) => {
  const {
    field: { name, value, onChange, ref: inputRef },
    fieldState: { error },
  } = useController({ name: fieldName, rules, defaultValue, control })

  return (
    <TextInputV2
      {...passProps}
      value={value}
      onChange={onChange}
      name={name}
      errorText={error?.message}
      inputRef={inputRef}
      invalid={Boolean(error?.message)}
    />
  )
}
